import React from 'react';
import { Redirect } from 'react-router-dom';

import { ApplicationWrapper, AuthType } from '@innovyze/stylovyze';
import { usePageRoutes } from '@Pages';

function withRootRedirect(pages: ReturnType<typeof usePageRoutes>) {
  const [{ to: firstRoute } = { to: '' }] = pages;
  if (!firstRoute) return pages;
  return [...pages, { to: '/', render: <Redirect to={firstRoute} /> }];
}

function App() {
  const pages = withRootRedirect(usePageRoutes());

  return (
    <ApplicationWrapper
      pages={pages}
      loginPicker={AuthType.Forge}></ApplicationWrapper>
  );
}

export default App;
